import './AmbientUtility.css';

import React from 'react';

interface AmbientUtilityProps {
  size?: number;
  onDismiss?: () => void;
}

export function AmbientUtility({ size = 40, onDismiss }: AmbientUtilityProps) {
  const handleClick = () => {
    onDismiss?.();
  };

  return (
    <svg
      className="ambientUtilitySvg"
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      onClick={handleClick}
      style={{ cursor: onDismiss ? 'pointer' : 'default' }}
    >
      <g className="utility-body">
        <g className="tail">
          <path
            d="M60 130 Q30 140 15 160 Q10 170 20 175 Q35 170 45 155 Q55 140 65 135"
            fill="#2d8a4e"
            stroke="#1e5f36"
            strokeWidth="2"
          />
          <path d="M20 175 L10 185 L25 178 L15 190 L28 180" fill="#ff6b35" />
        </g>

        <ellipse
          cx="70"
          cy="140"
          rx="12"
          ry="18"
          fill="#2d8a4e"
          stroke="#1e5f36"
          strokeWidth="1.5"
        />
        <path
          d="M65 155 L60 170 L68 168 L72 170 L75 155"
          fill="#2d8a4e"
          stroke="#1e5f36"
          strokeWidth="1"
        />

        <ellipse
          cx="90"
          cy="115"
          rx="40"
          ry="30"
          fill="#3ab06a"
          stroke="#2d8a4e"
          strokeWidth="2"
        />

        <ellipse cx="95" cy="125" rx="25" ry="15" fill="#8fd9a8" />
        <path
          d="M75 120 Q85 125 95 120 Q105 125 115 120"
          stroke="#3ab06a"
          strokeWidth="1"
          fill="none"
        />
        <path
          d="M78 128 Q88 133 98 128 Q108 133 112 128"
          stroke="#3ab06a"
          strokeWidth="1"
          fill="none"
        />

        <g className="wing">
          <path
            d="M85 95 Q70 60 90 40 Q100 50 95 70 Q110 45 120 35 Q120 55 105 75 Q125 55 140 50 Q130 70 105 90 Z"
            fill="#5dd98d"
            stroke="#2d8a4e"
            strokeWidth="2"
          />
          <path
            d="M85 95 Q92 70 95 70"
            stroke="#3ab06a"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M85 95 Q100 65 105 75"
            stroke="#3ab06a"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M85 95 Q110 70 105 90"
            stroke="#3ab06a"
            strokeWidth="1.5"
            fill="none"
          />
        </g>

        <ellipse
          cx="115"
          cy="135"
          rx="10"
          ry="15"
          fill="#3ab06a"
          stroke="#2d8a4e"
          strokeWidth="1.5"
        />
        <path
          d="M108 147 L105 162 L112 160 L117 162 L120 147"
          fill="#3ab06a"
          stroke="#2d8a4e"
          strokeWidth="1"
        />

        <path
          d="M120 100 Q140 85 150 75"
          stroke="#3ab06a"
          strokeWidth="25"
          strokeLinecap="round"
          fill="none"
        />

        <ellipse
          cx="155"
          cy="70"
          rx="22"
          ry="18"
          fill="#3ab06a"
          stroke="#2d8a4e"
          strokeWidth="2"
        />

        <ellipse
          cx="172"
          cy="75"
          rx="12"
          ry="10"
          fill="#3ab06a"
          stroke="#2d8a4e"
          strokeWidth="2"
        />

        <circle cx="180" cy="73" r="2" fill="#1e5f36" />

        <g className="eye">
          <ellipse cx="158" cy="65" rx="6" ry="7" fill="#fff" />
          <ellipse cx="160" cy="65" rx="3" ry="4" fill="#1a1a2e" />
          <circle cx="161" cy="63" r="1.5" fill="#fff" />
        </g>

        <path
          d="M145 55 Q140 40 148 30"
          stroke="#ff8c42"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M155 52 Q155 38 165 28"
          stroke="#ff8c42"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
        />

        <path
          d="M140 60 Q130 55 135 45 Q142 52 145 58"
          fill="#5dd98d"
          stroke="#2d8a4e"
          strokeWidth="1"
        />

        <g className="fire">
          <ellipse cx="195" cy="80" rx="15" ry="8" fill="#ff6b35" />
          <ellipse cx="200" cy="80" rx="10" ry="5" fill="#ffd93d" />
          <ellipse cx="188" cy="85" rx="8" ry="4" fill="#ff6b35" />
        </g>

        <path d="M70 95 L65 80 L75 95" fill="#ff8c42" />
        <path d="M85 90 L82 72 L92 90" fill="#ff8c42" />
        <path d="M100 88 L100 70 L108 90" fill="#ff8c42" />
        <path d="M115 92 L118 78 L125 95" fill="#ff8c42" />
      </g>
    </svg>
  );
}

export default AmbientUtility;
